module.exports = __webpack_public_path__ + "wheel_click.mp3";